module.exports = __webpack_public_path__ + "img/result-detail-sacrifice-outleft03.9524f119.svg";